import React from 'react';
import i18n from '../../i18n';
import { RefreshCw, Trophy, Medal, Award, ChevronDown, ChevronUp, Users } from 'lucide-react';
import { SaudiRiyalLogo } from '../logo/saudiLogo';
import '../../styles/components/bidding-comp.scss';

export class BiddersPosition extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loadMore: false,
    };
  }

  getRankIcon = (position) => {
    switch (position) {
      case 1:
        // return <Trophy size={20} className="rank-icon gold" />;
        return <span size={20} className="rank-number gold" >{position}</span>;

      case 2:
        // return <Medal size={20} className="rank-icon silver" />;
        return <span size={20} className="rank-number silver" >{position}</span>;
      case 3:
        // return <Award size={20} className="rank-icon bronze" />;
        return <span size={20} className="rank-number bronze" >{position}</span>;
      default:
        return <span className="rank-number">{position}</span>;
    }
  };

  render() {
    let top_bidders = this.props.top_bidders;
    let user = this.props.user;

    return (
      <div className="modern-bidders-position">
        <div className="bidders-card">
          <div className="card-header">
            <div className="header-content">
              <div className="header-title">
                <Trophy size={24} />
                {i18n.t('top_3_bidders')}
              </div>
              <button
                className="refresh-btn"
                onClick={this.props.loadTopBidders}
              >
                <RefreshCw
                  size={18}
                  className={`refresh-icon ${this.props.refresh_loading ? 'spinning' : ''}`}
                />
                {i18n.t('refresh')}
              </button>
            </div>
          </div>

          <div className="card-body">
            {top_bidders && top_bidders.length > 0 ? (
              <>
                <table className="bidders-table">
                  <thead className="table-header">

                    <th style={{ textAlign: 'left' }}>
                      {user.role !== 'U' ? i18n.t('username') : i18n.t('bidder_id')}
                    </th>
                    <th style={{ textAlign: 'center' }}>
                      {i18n.t('rank')}
                    </th>
                    <th style={{ textAlign: 'center' }}>
                      {i18n.t('amount')}
                    </th>

                  </thead>
                  <tbody>
                    {top_bidders.map((item, i) => {
                      const isCurrentUser = item.user_id === user.id;
                      const position = i + 1;
                      const isVisible = i <= 2 || this.state.loadMore;

                      if (!isVisible) return null;

                      return (
                        <tr
                          key={i}
                          className={`bidder-row ${isCurrentUser ? 'current-user' : ''}`}
                        >
                          <td className="table-cell" style={{ textAlign: 'left' }}>
                            <div className="bidder-info">
                              <div className="bidder-name">
                                {user.role !== 'CE' && user.role !== 'GM'
                                  ? item.enroll_number
                                  : item.username}
                              </div>
                            </div>
                          </td>

                          <td className="table-cell" style={{ textAlign: 'center' }}>
                            <div className="rank-container">
                              <div className={`rank-badge ${position === 1 ? 'gold' :
                                position === 2 ? 'silver' :
                                  position === 3 ? 'bronze' : 'regular'
                                } ${isCurrentUser ? 'current' : ''}`}>
                                {isCurrentUser && (
                                  <span style={{ fontSize: '0.5rem' }}>
                                    {i18n.t('my_rank')}:
                                  </span>
                                )}
                                {this.getRankIcon(position)}
                              </div>
                            </div>
                          </td>

                          <td className="table-cell" style={{ textAlign: 'center' }}>
                            <div className="bid-amount">
                              {item.bid_amount.toLocaleString()}
                              <span className="currency-symbol"><SaudiRiyalLogo /></span>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>

                {top_bidders.length > 3 && (
                  <div className="expand-controls">
                    <button
                      className="expand-btn"
                      onClick={() => this.setState({ loadMore: !this.state.loadMore })}
                    >
                      {this.state.loadMore ? (
                        <>
                          <ChevronUp size={16} />
                          {i18n.t('collapse')}
                        </>
                      ) : (
                        <>
                          <ChevronDown size={16} />
                          {i18n.t('expand')}
                        </>
                      )}
                    </button>
                  </div>
                )}
              </>
            ) : (
              <div className="no-bidders">
                <div className="no-bidders-icon">
                  <Users size={30} />
                </div>
                <div className="no-bidders-text">
                  {i18n.t('no_bidders_found')}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}